import Icon from '@mdi/react'
import styled from 'styled-components'
import theme from 'theme_'

export const SubscriptionTableHeaderContainer = styled.div`
  display: flex;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
  position: sticky;
  top: 128px;
  @media ${theme.devices.tablet} {
    position: unset;
    background-color: ${theme.colors.activeState};
    align-items: center;
  }
`

const HeaderColumns = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 120px;
  padding: 0 32px;
  @media ${theme.devices.tablet} {
    font-size: 20px;
  }
`

export const HeaderColumnFeature = styled(HeaderColumns)`
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
    flex-basis: 56%;
    justify-content: flex-start;
  }
`

export const HeaderColumnIncluded = styled(HeaderColumns)<{
  isColored: boolean
}>`
  flex-basis: 50%;
  line-height: 1.5;
  background-color: ${({ isColored }) =>
    isColored ? theme.colors.activeState : '#eee3da'};
  @media ${theme.devices.tablet} {
    flex-basis: 22%;
    line-height: 1.5;
    border-left: 1px solid ${theme.colors.commonShadow};
    border-right: 1px solid ${theme.colors.commonShadow};
    font-size: 16px;
  }
`

export const HeaderColumnEssentials = styled(HeaderColumns)<{
  isColored: boolean
}>`
  display: flex;
  flex-direction: column;
  font-weight: bold;
  line-height: 1.5;
  flex-basis: 50%;
  background-color: ${({ isColored }) =>
    isColored ? theme.colors.activeState : '#eee3da'};
  font-size: 20px;
  @media ${theme.devices.tablet} {
    flex-basis: 22%;
    flex-direction: column;
    padding: 0;
  }
  @media ${theme.devices.desktop} {
    padding: 0 ${theme.spacing.lg};
  }
`

export const HeaderColumnEssentialsIcon = styled(Icon)`
  color: ${theme.colors.successGreen};
  height: 34px;
`

export const HeaderColumnEssentialsPrice = styled.div`
  color: ${theme.colors.horizonOrange};
  font-size: 16px;
  font-weight: 300;
`
